import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight, Shield, Users, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import ExampleChatSnippets from "@/components/ExampleChatSnippets";
const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-xl font-bold">RealWordsOnly.com</h1>
          <Link to="/login">
            <Button variant="outline" size="sm">Login</Button>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <section className="container mx-auto px-4 py-16 md:py-24">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <div className="inline-block px-4 py-1 border border-primary text-primary text-sm mb-4">
              ANTI-AI • TEXT-ONLY • ZERO BS
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-center">
              <span className="text-primary font-sans font-semibold text-6xl text-center">Real People. Real Words. Authentic Thoughts.  
  No Bots, No AI Slop</span>
            </h1>
            
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Tired of deepfakes, algorithm feeds, and ego-bait? This is old-school internet. 
              Text-only forums where honest words matter more than likes.
            </p>

            <div className="flex gap-4 justify-center pt-4">
              <Link to="/signup">
                <Button size="lg" className="gap-2">
                  Start Posting <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
              <Link to="/feed">
                <Button size="lg" variant="outline">
                  Browse Threads
                </Button>
              </Link>
            </div>

            <p className="text-sm text-muted-foreground pt-2">
              Basic $2.49/mo • Premium $3.99/mo • Save 20% with Annual
            </p>
          </div>
        </section>

        {/* Chat Preview */}
        <section className="container mx-auto px-4 py-16 border-t border-border">
          <ExampleChatSnippets />
        </section>

        {/* Features */}
        <section className="container mx-auto px-4 py-16 border-t border-border">
          <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-8">
            <Card className="p-6 space-y-4">
              <Shield className="w-8 h-8 text-primary" />
              <h3 className="font-bold text-lg">No AI Bullshit</h3>
              <p className="text-sm text-muted-foreground">
                Text only. No images, videos, or deepfakes. Just honest conversation between real humans.
              </p>
            </Card>

            <Card className="p-6 space-y-4">
              <Zap className="w-8 h-8 text-primary" />
              <h3 className="font-bold text-lg">Pure chronological feed or follow your people. Hot Posts.  No trending, no viral chasing, no manipulation.</h3>
              <p className="text-sm text-muted-foreground">
                Pure chronological feed or follow your people. No trending, no viral chasing, no manipulation.
              </p>
            </Card>

            <Card className="p-6 space-y-4">
              <Users className="w-8 h-8 text-primary" />
              <h3 className="font-bold text-lg">Real Community</h3>
              <p className="text-sm text-muted-foreground">
                300 word limit per post. Forces clarity. Builds connection. Like the forums you grew up with.
              </p>
            </Card>
          </div>
        </section>

        {/* Manifesto */}
        <section className="container mx-auto px-4 py-16 border-t border-border">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold mb-6 text-center">The RealWordsOnly Manifesto</h2>
            <Card className="p-8 space-y-4 text-sm">
              <p>We're not here to go viral. We're not here to farm engagement.</p>
              <p>This is a throwback to when the internet was weird, honest, and human.</p>
              <p className="font-bold text-primary">No proof means no receipts required. Say your truth.</p>
              <p>No images means no deepfakes, no flexing, no visual manipulation.</p>
              <p>No algorithms means no echo chambers, no outrage optimization.</p>
              <p>Just forums. Just threads. Just words between people who remember when online meant something.</p>
              <p className="text-primary font-bold">Be real or GTFO.</p>
            </Card>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-border mt-16">
        <div className="container mx-auto px-4 py-8 text-center text-sm text-muted-foreground">
          <p>© 2025 RealWordsOnly.com • Anti-AI Text Forum</p>
          <p className="mt-2">Built for real humans who miss the old internet.</p>
        </div>
      </footer>
    </div>
  );
};
export default Index;